import "./index.scss";

import { Box } from "@mui/material";
import React from "react";

const PageNotFound = () => {
  return (
    <Box display="flex" flex={1} height="100vh" justifyContent="center" alignItems="center">
      <img
        alt="404"
        src={require("assets/images/ui/error-404.png")}
        width={window.innerWidth}
        height={window.innerHeight}
      />
    </Box>
  );
};

export default PageNotFound;
